import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { MepInsights } from "../../tabs/mep-insights/mep-insights";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { CustomerDetailsModel } from "../../../../../../models/customers/customer.models";
import * as Enumerable from "linq";

@autoinject
export class PrintMepInsightsDialog {

    model: MepInsights;
    sectionTopContributorsToEmissions?: boolean = true;
    sectionSmallestContributorsToEmissions?: boolean = true;
    sectionVesselEmissionsComparison?: boolean = true;
    sectionCorrelationWithPortTimeCallsPortCalls?: boolean = true;
    sectionCorrelationWithPortTimeCallsTugJobs?: boolean = true;
    sectionEmissionsByMonth?: boolean = true;
    sectionLongTermForecast?: boolean = true;
    customerDetails: CustomerDetailsModel;

    constructor(private dialogClientService: DialogClientService) { }

    activate(model: MepInsights) {
        this.model = model;

        //Top contributors to emissions
        this.sectionTopContributorsToEmissions = this.model.topContributorsToEmissionsViewModel.contributorsToEmissions ? true : null;

        //Smallest contributors to emissions
        this.sectionSmallestContributorsToEmissions = this.model.smallestContributorsToEmissionsViewModel.contributorsToEmissions ? true : null;

        //Vessel emissions comparison
        this.sectionVesselEmissionsComparison = this.model.vesselEmissionsComparisonViewModel.vesselEmissionsComparison ? true : null;

        //Correlation with port time calls
        this.sectionCorrelationWithPortTimeCallsPortCalls = this.model.correlationWithPortTimeCallsViewModelForPrintingPortCalls && this.model.correlationWithPortTimeCallsViewModelForPrintingPortCalls.chartViewModel ? true : null;

        //Correlation with port time calls
        this.sectionCorrelationWithPortTimeCallsTugJobs = this.model.correlationWithPortTimeCallsViewModelForPrinting && this.model.correlationWithPortTimeCallsViewModelForPrinting.chartViewModel ? true : null;

        //Emission by month
        this.sectionEmissionsByMonth = this.model.emissionsByMonthViewModel && this.model.emissionsByMonthViewModel.emissionsByMonthChart ? true : null;

        //Long term-forcast
        this.sectionLongTermForecast = this.model.longTermForecastViewModel && this.model.longTermForecastViewModel.longTermForecastResults ? true : null;

        this.customerDetails = CustomerDetailsModel.getCustomerDetailModelFromRSUser(window["rightshipUser"]);
    }

    attached() {
        this.model.emissionsByMonthViewModel.emissionsByMonthChart.initChart("chartdivprint");
        this.model.longTermForecastViewModel.longTermForecastChartViewModel.initChart("chartdiv2print");
        this.model.vesselEmissionsComparisonViewModel.vesselEmissionsComparisonPieChartViewModel.initVesselEmissionsComparisonPieChart("piechartdivprint");
    }

    close() {
        this.dialogClientService.hide();
    }

    printDocument() {
        //If the current user is a customer with a trial account
        if (this.customerDetails?.isMepTrial) {
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.TrialVersionDialog, { customerId: this.customerDetails.customerId, title: 'Print Report' });
        }
        else {
            $(".document-mep-insights").printThis({
                importCSS: true,
                importStyle: true,
                loadCSS: "/styles/core.min.css",
                canvas: true
            });
        }
    }

    getGhgFilters(selectedGhgRatingItems: string[]) {

        const availableRatings = ["A", "B", "C", "D", "E", "U"];
        const ratings = Enumerable.from(selectedGhgRatingItems)
            .where(x => availableRatings.indexOf(x) > -1)
            .distinct()
            .toArray();

        return {
            ratings: ratings,
            isPlus: selectedGhgRatingItems.indexOf("isRatingPlus") > -1,
            isNotPlus: selectedGhgRatingItems.indexOf("isNotRatingPlus") > -1,
            isVerified: selectedGhgRatingItems.indexOf("isVerified") > -1,
            isNotVerified: selectedGhgRatingItems.indexOf("isUnverified") > -1,
        }
    }
}